import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Entities,
    fetchByCompanyId,
    fetchById,
    getEntities,
    getUpdatedEntity,
    patch,
    Projection,
    save,
    TOMCAT_URL,
} from 'src/common';
import autoBind from 'react-autobind';
import { getOwnCompany } from 'src/selectors/bus-companies';

import CalendarSeasonCalculationForm from 'src/components/administration/calendar-season-calculation/components/calendar-season-calculation-form';

class CalendarSeasonCalculationModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id, selectedCompany, fetchById } = this.props;
        this.props.fetchByCompanyId(Entities.CALCULATION, selectedCompany);
        // fetchById(id, Entities.CALENDAR_SEASON, selectedCompany, Projection.FULL);
        // if (!isCreate) fetchById(id, Entities.CALENDAR_SEASON_CALCULATION, selectedCompany, Projection.FULL);
        // else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { calendarSeasonCalculation } = nextProps;
        //
        // if (!this.state.startedFetching && calendarSeasonCalculation.isFetching)
        //     this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { calendarSeasonCalculation, isCreate, selectedCompany, t, calculations, calendarSeasons } = this.props;
        const finishFetching = !this.state.startedFetching && !calculations.isFetching;
        if (finishFetching) {
            let initialValues;
            if (!isCreate && calendarSeasonCalculation) {
                initialValues = {
                    id: calendarSeasonCalculation.id,
                    name: calendarSeasonCalculation.name,
                    seasonAndCalculations: calendarSeasonCalculation.seasonAndCalculations,
                    company: `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${selectedCompany}`,
                };
            } else {
                initialValues = {
                    company: `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${selectedCompany}`,
                };
            }

            return (
                <CalendarSeasonCalculationForm
                    t={t}
                    initialValues={initialValues}
                    onSubmit={this.handleSubmit}
                    ref={ref => (this.childForm = ref)}
                    selectedCompany={selectedCompany}
                    calculations={calculations}
                    calendarSeasons={calendarSeasons}
                />
            );
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { isCreate, handleClose, patch, save, selectedCompany } = this.props;

        if (isCreate) {
            const request = {
                ...data,
                seasonAndCalculations: data.seasonAndCalculations.map(item => {
                    return {
                        // calendarSeasonCalculation: `${TOMCAT_URL}api/${Entities.CALENDAR_SEASON_CALCULATION.repository}/${data.id}`,
                        calculationId: item.calculation.id,
                        calendarSeasonId: item.calendarSeason.id,
                    };
                }),
            };
            save(
                request,
                Entities.CALENDAR_SEASON_CALCULATION,
                selectedCompany,
                Projection.FULL,
                null,
                'save-calendar-season-calculation',
            ).then(() => {
                this.props.fetchByCompanyId(
                    Entities.CALENDAR_SEASON_CALCULATION,
                    this.props.selectedCompany,
                    Projection.FULL,
                );
            });
        } else {
            const request = {
                ...data,
                seasonAndCalculations: data.seasonAndCalculations.map(item => {
                    return {
                        calendarSeasonCalculation: `${TOMCAT_URL}api/${Entities.CALENDAR_SEASON_CALCULATION.repository}/${data.id}`,
                        calculation: `${TOMCAT_URL}api/${Entities.CALCULATION.repository}/${item.calculation.id}`,
                        calendarSeason: `${TOMCAT_URL}api/${Entities.CALENDAR_SEASON_CALCULATION.repository}/${item.calendarSeason.id}`,
                    };
                }),
            };
            patch(request, Entities.CALENDAR_SEASON_CALCULATION, selectedCompany, Projection.FULL, null);
        }
        handleClose();
    }
}

const mapStateToProps = state => {
    return {
        calendarSeason: getUpdatedEntity(state, Entities.CALENDAR_SEASON, state.selectedCompany),
        selectedCompany: state.selectedCompany,
        calculations: getEntities(state, Entities.CALCULATION, state.selectedCompany),
        busCompany: getOwnCompany(state),
        // calendarSeasonCalculation: getEntities(state, Entities.CALENDAR_SEASON_CALCULATION, state.selectedCompany),
    };
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        fetchByCompanyId,
        patch,
        save,
    },
    null,
    { withRef: true },
)(CalendarSeasonCalculationModal);
